import React, { forwardRef, useEffect, useState } from "react";
import './cutomerview.css'
import { Form } from "antd";
import { useParams } from "react-router-dom";
import { dropdownService, invoiceService } from "../../../services";
import { ROLES } from "../../../constants";

export const InvoicePdf = forwardRef(({ invoice, customer, data }, ref) => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [charges, setCharges] = useState([]);
  const [disable, setDisable] = useState(true);
  const [total, setTotal] = useState(null)
  const role = localStorage.getItem("role");

  // const handlePrint = () => {
  //   const divToPrint = document.getElementById("printableDiv");
  //   if (!divToPrint) return;

  //   const originalContent = document.body.innerHTML; // Store the original content
  //   const printContent = divToPrint.innerHTML;

  //   // Create a new style tag to center the content
  //   const styleTag = document.createElement("style");
  //   styleTag.innerHTML = `

  //       body {
  //         display: flex;
  //         justify-content: center;
  //         align-items: flex-start;
  //         height: auto;
  //         margin: 5;
  //         padding: 5;
  //       }
  //       #printableDiv {
  //         width: 100%;
  //         max-width: 800px; /* Adjust based on your preference */
  //         padding: 20px;
  //         box-sizing: border-box;
  //         text-align: center; /* Optional: centers text within the div */
  //         }

  //       @page {
  //         size: auto;
  //       }

  //       `;

  //   // Temporarily add the style to the head section
  //   document.head.appendChild(styleTag);

  //   // Replace body content with the div content
  //   document.body.innerHTML = printContent;

  //   // Open print dialog
  //   window.print();

  //   // Restore original content and remove the dynamically added style
  //   document.body.innerHTML = originalContent;
  //   document.head.removeChild(styleTag);

  //   // Reload the page to fix any broken scripts
  //   // window.location.reload();
  // };

  const initialize = async () => {
    if (role === ROLES.ADMIN) {
      const { success, data } = await invoiceService.viewInvoice(id);
      if (success) {
        const response = await invoiceService.getInvoiceCharges(id);
        if (response.success) {
          setCharges(response.data.extras)
          form.setFieldsValue({
            charges: response.data.extras.map((extra) => ({
              first: extra.extra_charge,
              last: extra.extra_charge_amount,
            }))
          });
        }
        // setInvoice(data);
        setTotal(parseFloat(data.subTotal) - parseFloat(data.invoice.discount) - Math.abs(parseFloat(data.credit_amount)));
        form.setFieldsValue({
          discount: data?.invoice?.discount,
        });
        form2.setFieldsValue({
          amount: data.invoice.total,
        });
        if (data?.invoice?.total === 0) {
          setDisable(true);
          form2.setFieldsValue({
            status: 0,
          });
        }
      }
    } else if (role === ROLES.CUSTOMER) {
      const { success, data } = await invoiceService.viewCustomerInvoice(id);
      if (success) {
        // setInvoice(data);  
        form.setFieldsValue({
          discount: data?.invoice?.discount,
        });
      }
    }
  };

  useEffect(() => {
    initialize();
  }, [])

  // useEffect(() => {
  //   if (location.search.includes("download=true") && invoice?.id) {
  //     handlePrint();
  //   }
  // }, [location, invoice]);


  return (
    <div
      ref={ref} // ✅ attach ref here
      id="printableDiv"
      style={{
        width: "100%",            // ✅ exact A4 width in px
        minHeight: "1000px",       // ✅ A4 height in px (96 DPI)
        margin: "0 5px",          // ✅ center horizontally
        boxSizing: "border-box",
        background: "#fff",        // white background for clean PDF
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",   // ✅ instead of 800px
          maxWidth: "780px", // (794px - 2*40px padding)
          margin: "0 auto",
        }}
      >
        <div className="main">
          {/* /////top start//////// */}
          <div className="top">
            <div>
              <img
                src="/images/ctrade-logo.png"
                alt=""
                style={{ width: "100px", height: "55px" }}
              />
              <h3>CTRADE USA INC</h3>
            </div>
            <div style={{ fontSize: "15px", lineHeight: 1.2, textAlign: "right" }}>
              3902 SWINGLE RD
              <br />
              HOUSTON TX 77047
              <br />
              UNITED STATES
              <br />
              Mobile: +1 832-819-2622 <br />
              Email: trade@ctrade.us
            </div>
          </div>
          <h1 className="invoice-heading pr-4">INVOICE Number: {invoice?.id}</h1>
          {/* /////top end//////// */}
          <div className="seperatorTwo"></div>
          {/* /////second start//////// */}
          <div className="second">
            <h4 style={{ textTransform: 'capitalize' }}>
              Bill-to Party :   {customer?.name}
            </h4>
            <div>
              <h4 >
                Invoice Date :   {invoice?.date}
              </h4>
              <h4 >
                Invoice Due :   {invoice?.due_date}
              </h4>
              <h4 >
                Payment terms :   Payable immediately
              </h4>
            </div>
          </div>
          {/* /////second end//////// */}
          <h3
            className="subHeading"
            style={{ fontSize: "18px" }}
          >
            <span style={{ fontWeight: "bold" }}>BOOKING Number :</span> {invoice?.vehicles[0]?.booking_no}
          </h3>
          <div className="seperatorTwo"></div>
          {/* /////third start//////// */}
          <div className="third">
            <div style={{ marginLeft: "10px" }}>
              <h4>POL : HOUSTON  </h4>
              <h4>POD :   </h4>
              <h4>
                Product Id : Ctrade U.S.A
              </h4>
            </div>
            <div style={{ marginLeft: "3vw" }}>
              <h4>
                Place of Receipt : Houston
              </h4>
              <h4> Place of Delivery :  </h4>
            </div>
          </div>
          {/* /////third end//////// */}
          <div className="seperator"></div>
          <h2 className="subHeading" style={{ marginTop: "10px" }}>
            TOTAL AMOUNT DUE
          </h2>
          {/* /////fourth start//////// */}
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tr
              className="table"
              style={{
                border: "2px solid #B83D3D",
                paddingLeft: "10px",
                paddingRight: "10px",
                paddingBottom: "8px",
              }}
            >
              <td style={{ fontWeight: "bold", fontSize: "14px" }}>Condition</td>
              <td style={{ fontWeight: "bold", fontSize: "14px" }}>Rate</td>
              <td style={{ fontWeight: "bold", fontSize: "14px" }}>BaseValue</td>
              <td style={{ fontWeight: "bold", fontSize: "14px" }}>Total (USD)</td>
            </tr>
            <tr
              className="table"
              style={{
                paddingLeft: "1vw",
                paddingRight: "1vw",
              }}
            >
              <td style={{ fontSize: "14px" }}>Net Value </td>
              <td></td>
              <td></td>
              <td style={{ fontSize: "14px" }}> {invoice?.total}.00</td>
            </tr>
            <tr
              className="table"
              style={{
                paddingLeft: "1vw",
                paddingRight: "1vw",
              }}
            >
              <td style={{ fontSize: "14px" }}>Discount</td>
              <td></td>
              <td></td>
              <td style={{ fontSize: "14px" }}>
                {invoice?.discount}.00
              </td>
            </tr>
            {/* {data?.credit_amount ? */}
            <tr
              className="table"
              style={{
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              <td style={{ fontSize: "14px" }}>Credit Amount</td>
              <td></td>
              <td></td>
              <td style={{ fontSize: "14px" }}>
                {data?.credit_amount}.00
              </td>
            </tr>
            {/* : <></>} */}
            <tr
              className="table"
              style={{
                border: "2px solid #B83D3D",
                paddingLeft: "10px",
                paddingRight: "10px",
                paddingBottom: "8px",
                marginTop: "2px",
              }}
            >
              <td style={{ fontWeight: "bold", fontSize: "16px" }}>Amount Due</td>
              <td></td>
              <td></td>
              <td style={{ fontWeight: "bold" }}></td>
              <td style={{ fontWeight: "bold", fontSize: "16px" }}>
                ${total?.toLocaleString() || "0.00"}
              </td>
            </tr>
          </table>

          <div className="vehicle-details" style={{ width: "805px" }}>
            {invoice?.vehicles?.length > 0 && <table >
              <thead>
                <tr
                  style={{
                    justifyContent: "space-between",
                    display: "flex",
                    width: "802px",
                  }}
                >
                  <th
                    style={{
                      width: "170px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Vehicle
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Receiving Date
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Loading Date
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    Days
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Storage
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Freight Loading
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Towing
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Chassis
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {invoice?.vehicles?.map((vehicle, index) => {
                  let frieghtLoading = parseFloat(vehicle?.freight_charges) + parseFloat(vehicle?.loading_charges);
                  let amount = parseFloat(vehicle?.yard_charges) + frieghtLoading + parseFloat(vehicle?.towing_charges) + parseFloat(vehicle?.chasis);
                  return (
                    <>
                      <tr
                        // key={index}
                        style={{
                          justifyContent: "space-between",
                          display: "flex",
                          width: "802px",
                          borderBottom: "2px solid #b83d3d"
                        }}
                      >
                        <td
                          style={{
                            width: "170px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          <div>
                            {vehicle?.year} {vehicle?.vehicle}
                          </div>
                          <div
                            style={{
                              marginTop: "4px",
                              fontSize: "11px",
                              color: "#666",
                            }}
                          >
                            {vehicle?.chasis_no}
                          </div>
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          {vehicle.date_rcd.slice(0, 10)}
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          {invoice?.pull_out_date}
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {vehicle.days}
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          ${vehicle?.yard_charges?.toLocaleString() || "0.00"}
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          ${frieghtLoading}.00
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          ${vehicle?.towing_charges}.00
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          ${vehicle?.chasis}.00
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          ${amount.toLocaleString() || "0.00"}
                        </td>
                      </tr>
                    </>
                  )
                })}
              </tbody>
              {invoice?.extras?.length > 0 &&
                <>
                  <thead style={{ borderTop: "1px solid #B83D3D" }}>
                    <tr style={{ display: 'flex', justifyContent: "space-between", borderBottom: "1px solid #B83D3D" }}>
                      <th>Extra Charges</th>
                      <th style={{ paddingRight: 5 }}>Total (USD)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice?.extras?.map((extra, index) => (
                      <>
                        <tr style={{ display: "flex", justifyContent: "space-between", paddingRight: 5 }}>
                          <td>
                            ${extra.extra_charge}
                          </td>
                          <td>
                            ${extra.extra_charge_amount}
                          </td>
                        </tr>
                      </>

                    ))}
                  </tbody>
                </>
              }
            </table>}
            {(invoice?.invoice?.vehicles?.length == 0 && invoice.extras.length > 0) && (
              <section className="extras-details">
                <table>
                  <thead >
                    <tr>
                      <th>
                        Description
                      </th>
                      <th>
                        Total (USD)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice?.extras?.map((extra, index) => (
                      <>
                        <tr key={index}
                          style={{
                            // ?display: "flex",
                            // justifyContent: "space-between",
                            fontSize: "20px",
                            // width: "798px",
                          }}>
                          <td>
                            ${extra.extra_charge}
                          </td>
                          <td>
                            ${extra.extra_charge_amount}
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>

              </section>
            )}
          </div>
          {/* /////seven end//////// */}
          {/* <div className="seperator" style={{ marginTop: "1vh" }}></div> */}
          <div className="break-div" style={{ width: "805px" }} >
            <div
              className="break-div"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <div style={{ border: "2px solid #b83d3d", width: '100%', display: 'flex', justifyContent: "end" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "100px auto", // Two columns: 150px for headings, auto for values
                    gap: "5px 0px", // Row and column spacing
                    alignItems: "center",
                    fontSize: "12px",
                    textAlign: "left",
                    // backgroundColor: 'red',
                    // justifyContent: "end",
                    padding: 5,
                    marginRight: '28px'
                  }}
                >
                  <div style={{ fontWeight: "bold" }}>SubTotal:</div>
                  <div>
                    ${invoice?.sub_total?.toLocaleString() || "0.00"}
                  </div>

                  <div style={{ fontWeight: "bold" }}>Discount:</div>
                  <div>
                    ${invoice?.discount?.toLocaleString() || "0.00"}
                  </div>
                  {/* {data?.credit_amount ?
                    <> */}
                  <div style={{ fontWeight: "bold" }}>Credit Amount:</div>
                  <div>
                    ${data?.credit_amount?.toLocaleString() || "0.00"}
                  </div>
                  {/* </> : <></>
                  } */}

                  <div style={{ fontWeight: "bold" }}>Total:</div>
                  <div>${total?.toLocaleString() || "0.00"}</div>
                </div>
              </div>
            </div>
            {/* <div className="seperator" style={{ marginTop: "1vh" }}></div> */}
            {/* /////eight start//////// */}
            {invoice?.vehicles?.length > 0 && <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  width: "400px",
                  marginLeft: "3vw",
                }}
              >
                <div
                  style={{
                    width: "400px",

                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <h5 style={{ width: "160px" }}>No </h5>
                  <h5 style={{ width: "260px" }}>Container Number</h5>
                  <h5 style={{ width: "120px" }}>Size</h5>
                </div>
                <div
                  style={{
                    width: "400px",
                    display: "flex",
                    justifyContent: "space-between",
                    borderTop: "1px solid #666",
                  }}
                >
                  <h5 style={{ width: "160px" }}>1</h5>
                  <h5 style={{ width: "260px" }}>
                    {invoice?.vehicles[0]?.container_no}
                  </h5>
                  <h5 style={{ width: "120px", }}>
                    {invoice?.vehicles[0]?.container_size}
                  </h5>
                </div>
              </div>
            </div>}
            <div>
              <h5 style={{ fontSize: "15px", fontWeight: "bold", paddingLeft: 5 }}>{invoice?.description}</h5>
            </div>
          </div>
          {/* /////eight end//////// */}
          <div className="seperator" style={{ marginTop: "3vh" }}></div>
          <div className="acc-info ">
            <div className="top top2">
              <div>
                <img
                  src="/images/ctrade-logo.png"
                  alt=""
                  style={{ width: "100px", height: "55px" }}
                />
                <h3>CTRADE USA INC</h3>
              </div>
              <div style={{ fontSize: "14px", lineHeight: "10px" }}>
                3902 SWINGLE RD
                <br />
                HOUSTON TX 77047
                <br />
                UNITED STATES
                <br />
                Mobile: +1 832-819-2622 <br />
                Email: trade@ctrade.us
              </div>
            </div>
            <div className="top2 seperatorTwo"></div>
            <h5
              style={{
                marginLeft: "0vw",
                marginBottom: "8px",
                fontWeight: "bolder",
                marginTop: "20px",
              }}
            >
              Account Information
            </h5>
            {/* /////nine start//////// */}
            <div
              style={{
                display: "flex",
                marginLeft: "0vw",
                height: "3vh",
              }}
            >
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Account Name
              </h5>
              <h5 style={{ fontWeight: "lighter" }}> : CTRADE USA INC </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Bank Name
              </h5>
              <h5 style={{ fontWeight: "lighter" }}> : BANK OF AMERICA </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Account Number
              </h5>
              <h5 style={{ fontWeight: "lighter" }}> : 4881 2067 0589</h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Routing Number
              </h5>
              <h5 style={{ fontWeight: "lighter" }}>
                : 111000023/111000025 (PAPER & ELECTRONICS){" "}
              </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Routing Number
              </h5>
              <h5 style={{ fontWeight: "lighter" }}>
                : 026009593 ( WIRE TRANSFER - DOMESTIC ){" "}
              </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Swift Code
              </h5>
              <h5 style={{ fontWeight: "lighter" }}> : (US DOLLAR) BOFAUS3N </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Branch Address
              </h5>
              <h5 style={{ fontWeight: "lighter" }}>
                : BANK OF AMERICA, N.A, 222 BROADWAY, NEWYORK, NY 10038
              </h5>
            </div>
            {/* /////nine end//////// */}
            <h5
              style={{
                fontWeight: "lighter",
                marginTop: "6vh",
                marginLeft: "0vw",
                marginRight: "0vw",
                color: "#53575A",
              }}
            >
              We do not accept CARD payments, only cashier's cheques or direct
              bank transfers.Any additional charges Government charges if any are
              applied will be charged at actual Payment should fall into the
              CTrade USA Inc account within 10 days after loading the container.
              <br />
              Any dispute in invoice should be raised within 07 days from the
              issue date otherwise it will be considered as confirmed.
              <br />
              <br /> Any invoice delayed from the due date will be subject to $100
              as late fees15 Day free at facilities there after $15 Day/Car from
              the day of receiving in and out charges will be $100 subject to
              storage charges.
            </h5>
            <h5
              style={{
                marginLeft: "0vw",
                marginRight: "0vw",
                fontWeight: "bolder",
              }}
            >
              Note*: Payment against this invoice will be accepted as terms and
              conditions confirmed. In case of delay in payment ctrade usa will
              not be responsbile for any storage demarruages/detentions
            </h5>
            <div
              className="seperatorTwo"
              style={{
                marginTop: "3vh",
                height: "1px",
                backgroundColor: "#8F9CA6",
              }}
            ></div>
            <h5
              style={{
                textAlign: "center",
                color: "#8F9CA6",
                fontWeight: "lighter",
                marginTop: "12px",
              }}
            >
              THANK YOU FOR DOING BUSINESS WIITH CTRADE USA INC.
            </h5>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
    </div >
  );
});

export default InvoicePdf;
